<template>
  <li class="contact-item">
    <div class="contact-details">
      <div class="contact-info">
        <div class="contact-name">
          {{ name }}
        </div>
      </div>
    </div>
    <div class="number-details">
      {{numberFormatter(number)}}
    </div>
  </li>
</template>

<script>
import { phoneNumberFormatter } from "@/globals/globals";

export default {
  name: 'PersonalContactItem',
  props: {
    type: {required: true},
    name: {required: true},
    number: {required: true},
  },
  data(){
    return{

    }
  },
  methods: {
    numberFormatter(number) {
      if(number){
        return phoneNumberFormatter(number);
      }
    }
  }
}

</script>
